'use client';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useWindowDimensions } from '@/hooks/use-window-dimensions';
import { filtersLoad } from '@/store/calendar-filters';
import { WithLang } from '@/types/general';
import { WithCities } from '@/types/platform-data';
import { screenBreakpoints, storageKeys } from '@/utils/constants';
import { Cookies } from '@/utils/cookies';

import CalendarDesktop from './calendar.desktop';
import CalendarMobile from './calendar.mobile';

export default function CalendarClient(props: WithLang<WithCities>) {
    const dispatch = useDispatch();

    const { dimensions } = useWindowDimensions();

    useEffect(() => {
        const filterPresetId = Cookies.get(storageKeys.filterPreset);
        if (filterPresetId) Cookies.remove(storageKeys.filterPreset);

        dispatch(
            filtersLoad({
                countryCode: props.countryCode,
                cities: props.cities,
                filterPresetId: filterPresetId,
            }),
        );
    }, [dispatch, props.countryCode, props.cities]);

    return dimensions.width >= screenBreakpoints.md ? (
        <CalendarDesktop lang={props.lang} />
    ) : (
        <CalendarMobile lang={props.lang} />
    );
}
